import './Home.css'
import {ParallaxBanner} from 'react-scroll-parallax'
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { Link } from 'react-router-dom'


function Home() {

  const prefillData = {subject: "get_an_estimate"}

  return (
    <div className='homePage'>
      <ParallaxBanner
        layers={[
          {image: 'assets/bg1.jpg', speed:-20, opacity: [1, 0]}
        ]}
        className="background"
      >
        <div className="homeTitleContainer">
          <h1 style={{fontSize:"48px", opacity:"0", animation:"fadeIn 2s forwards"}}>
            Quality professional contracting in the Muncie, IN. area.
          </h1>
          <h1 style={{border: "1px solid black", borderRadius:"15px", background: "tomato", padding:"10px", opacity:"0", animation:"fadeIn 2s forwards"}}>
              <Link to={{pathname: "/Contact/get_an_estimate"}}> Get an Estimate </Link>
          </h1>
        </div>
      </ParallaxBanner>

      <div className="subtitleContainer">
          <p className='homeSubtitleText'>
            We are a local family-based business that focuses on custom carpentry,
            remodeling, and repairs with an extensive background in foundation repair and re-leveling homes.
            All local estimates are free, and first-time clients are eligible for a discount.
          </p>
      </div>

      <div className="mainContent">

        <div className="showcaseRow">

          <div className="showcaseItem">
            <img src="assets/1.jpg" style={{height:"60vh", overflow: 'hidden'}}/>
          </div>

          <div className="showcaseText">
            <p>We specialize in custom carpentry and all repairs below the floor. Whether you need a portion of your foundation replaced or a new shed, deck, or fence, we're the ones to call.</p>
          </div>

        </div>

        <hr/>

        <div className="showcaseRow">

          <div className="showcaseText">
            <p>Renovations, remodeling, repairs, custom woodworking, and more. Chances are if you need something done, we can do it.</p>
          </div>

          <div className="showcaseItem">
            <img src="assets/2.jpg" style={{height:"60vh", overflow: 'hidden'}}/>
          </div>
          
        </div>
        
        <hr/>

        <div className="showcaseRow">

          <div className="showcaseItem">
            <img src="assets/3.jpg" style={{height:"60vh", overflow: 'hidden'}}/>
          </div>

          <div className="showcaseText">
            <p>All local estimates are free. Call or email us now to schedule one today!</p>
          </div>

        </div>
        <hr/>
      </div>
    </div>
    
  )
}

export default Home
/*

*/